export default __webpack_public_path__ + "static/media/big-yellow-star.dc90c2f9.svg";